import type {
  ICompanyPostSetting,
  IEmployeePostTypeSummary,
  IFrame,
  IPostCard,
  ISharingComplaints,
} from '@/types/Data'
import type {
  IDateRange,
  IGetEmployeeByPostType,
  IGetPostList,
  IGetPostReportList,
  IGetPostSettingsList,
  IPayloadPostCard,
  IPayloadPostSetting,
  IUpdateFrame,
  IUpdatePostReport,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class PostServices extends BaseService {
  GetFrameList() {
    return this.GET<IFrame[]>(this.PATHS.GET_FRAME_LIST)
  }

  UpdateFrame(payload: IUpdateFrame) {
    return this.POST<void>(this.PATHS.UPDATE_FRAME, payload)
  }

  GetPostList(payload: IGetPostList) {
    return this.POST<any[]>(this.PATHS.GET_POST_LIST, payload)
  }

  GetEmployeeByPostType(payload: IGetEmployeeByPostType) {
    return this.POST<IEmployeePostTypeSummary>(this.PATHS.GET_EMPLOYEE_BY_POST_TYPE, payload)
  }

  GetEmployeePostTypeExcel(payload: IDateRange) {
    return this.EXCEL(this.PATHS.GET_EMPLOYEE_BY_POST_TYPE, true, payload)
  }

  GetPostCardList() {
    return this.GET<IPostCard[]>(this.PATHS.GET_POST_CARD_LIST, { PostTypeId: null })
  }

  CreatePostCard(payload: IPayloadPostCard) {
    return this.POST<IPostCard>(this.PATHS.CREATE_POST_CARD, JsonToFormData(payload))
  }

  UpdatePostCard(payload: IPayloadPostCard) {
    return this.POST<IPostCard>(this.PATHS.UPDATE_POST_CARD, JsonToFormData(payload))
  }

  DeletePostCard(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_POST_CARD, { Id })
  }

  GetCompanyPostSettingList(payload: IGetPostSettingsList) {
    return this.GET<ICompanyPostSetting[]>(this.PATHS.GET_COMPANY_POST_SETTING_LIST, payload)
  }

  CreateCompanyPostSetting(payload: IPayloadPostSetting) {
    return this.POST<string>(this.PATHS.CREATE_COMPANY_POST_SETTING, JsonToFormData(payload))
  }

  UpdateCompanyPostSetting(payload: IPayloadPostSetting) {
    return this.POST<string>(this.PATHS.UPDATE_COMPANY_POST_SETTING, JsonToFormData(payload))
  }

  DeleteCompanyPostSetting(CompanyPostSettingId: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_POST_SETTING, { CompanyPostSettingId })
  }

  GetPostReportList(payload: IGetPostReportList) {
    return this.GET<ISharingComplaints[]>(this.PATHS.GET_POST_REPORT_LIST, payload)
  }

  UpdatePostReport(payload: IUpdatePostReport) {
    return this.POST<void>(this.PATHS.UPDATE_POST_REPORT, payload)
  }

  DeleteComment(CommentId: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMMENT, { PostCommentId: CommentId })
  }
}
